<script setup lang="ts">
import allGamesPreview from '@/assets/components/mainBanner/allGames-preview.webp'
import allGames from '@/assets/components/mainBanner/allGames.webp'

const { games, gameOrder } = siteUtils
const slides = [{ img: allGames, preview: allGamesPreview, logo: '' }]
gameOrder.forEach((order) => {
  slides.push({ img: games?.[order]?.gameBanner ?? '', preview: games?.[order]?.gameBannerPreview ?? '', logo: games?.[order]?.logo ?? '' })
})
</script>

<template>
  <div class="main-banner w-full big:max-w-(--breakpoint-xl) mx-auto big:mt-5 big:px-4">
    <el-carousel
      motion-blur
      arrow="never"
      height="auto"
      trigger="click"
      class="big:rounded-3xl"
    >
      <el-carousel-item
        v-for="(slide, index) in slides"
        :key="index"
        style="padding-bottom: var(--gs-ratio)"
      >
        <div class="absolute inset-0 ">
          <el-image
            :src="slide.img"
            fit="cover"
            :alt="`slide ${index}`"
            class="object-cover object-top w-full h-full"
          >
            <template
              v-if="slide.preview"
              #placeholder
            >
              <img
                :src="slide.preview"
                :alt="`slide preview ${index}`"
                class="object-cover object-top w-full h-full block"
              >
            </template>
          </el-image>
          <img
            v-if="slide.logo"
            :src="slide.logo"
            alt="logo"
            class="w-28 big:w-36 absolute top-3 right-1"
          >
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style scoped lang="postcss">
.main-banner {
  --gs-ratio: 56%;

  & :deep(.el-carousel__container) {
    padding-bottom: var(--gs-ratio)!important;
    height: auto !important;
  }

  & :deep(.el-carousel) {
    --el-carousel-indicator-width: 15px;
  }

  @media (width >= 900px) {
    --gs-ratio: 40%;

    & :deep(.el-carousel) {
      --el-carousel-indicator-width: 30px;
    }
  }
}
</style>
